import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createMagicLink,
  fetchMyMagicLinks,
  revokeMagicLink,
  type MagicLinksScope,
  type MagicLinkRow,
} from "./api";

/** All magic links the viewer can see, aggregated across their feed signals. */
export function useMyMagicLinks(scope: MagicLinksScope) {
  return useQuery<MagicLinkRow[]>({
    queryKey: ["magic-links", scope],
    queryFn: () => fetchMyMagicLinks(scope),
    staleTime: 15_000,
  });
}

/** Revoke a magic link, then refresh the list. */
export function useRevokeMagicLink() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (magicLinkId: string) => revokeMagicLink(magicLinkId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["magic-links"] }),
  });
}

/** Create a magic link for a signal, then refresh the list (Settings, admin only). */
export function useCreateMagicLink() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ signalId, recipientId }: { signalId: string; recipientId: string }) =>
      createMagicLink(signalId, recipientId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["magic-links"] }),
  });
}
